export interface ICountry {
  abbreviation: string;
  translatedName: string;
}
